import { z } from 'zod'
import { LeadForm } from './leadForm'
import { User } from './user'
import { Workspace } from './workspace'

export const UserAdminSearch = User.pick({
  id: true,
  image: true,
  email: true,
  name: true,
}).extend({
  workspaces: z.array(z.string()),
})
export type UserAdminSearch = z.infer<typeof UserAdminSearch>

export const WorkspaceAdmin = z.object({
  workspace: Workspace,
  users: z.array(z.object({
    email: z.string().email(),
    id: z.string(),
  })),
  numberOfResponses: z.number(),
})
export type WorkspaceAdmin = z.infer<typeof WorkspaceAdmin>

export const FormAdmin = z.object({
  form: LeadForm,
  numberOfResponses: z.number(),
  workspace: Workspace.nullish(),
})
export type FormAdmin = z.infer<typeof FormAdmin>

